import React, { useState } from "react";
import { Users, UserPlus } from "lucide-react";
import MainLayout from "../components/MainLayout";
import { useQuery } from "@apollo/client";
import UserModal from "../components/UserModal";
import { GET_ALL_USERS } from "../apollo/Queries";
import UsersTable from "../components/UsersTable";

export default function UsersPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const { data, loading } = useQuery(GET_ALL_USERS, {
    variables: {
      page: 0,
      size: 10
    }
  });

  const users = data?.allUsers?.content;

  const handleEdit = (user) => {
    setEditingUser(user);
    setIsModalOpen(true);
  };

  const handleAddUser = () => {
    setEditingUser(null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingUser(null);
  };

  return (
    <MainLayout page="Users">
      <div className="space-y-10 animate-fade-in-up">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 bg-white p-10 rounded-[2.5rem] shadow-[0_20px_60px_rgba(0,0,0,0.02)] border border-gray-100 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-premium-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>

          <div className="relative z-10 space-y-2">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-premium-gold animate-pulse"></div>
              <span className="text-[10px] font-black uppercase tracking-[0.4em] text-premium-gold/80">User Management</span>
            </div>
            <h2 className="text-4xl font-black text-premium-teal tracking-tighter">User <span className="text-premium-gold">Management</span></h2>
            <p className="text-sm text-gray-400 font-light max-w-md">Manage users and their roles.</p>
          </div>

          <button
            className="premium-button relative z-10 flex items-center gap-3 bg-premium-teal text-white px-10 py-5 rounded-[1.5rem] font-black text-xs uppercase tracking-widest shadow-2xl shadow-premium-teal/20 active:scale-95 transition-all"
            onClick={handleAddUser}
          >
            <UserPlus size={20} className="text-premium-gold" />
            Register User
          </button>
        </div>

        {/* Content Section */}
        <div className="bg-white rounded-[3rem] shadow-[0_20px_60px_rgba(0,0,0,0.03)] border border-gray-100 p-2 overflow-hidden relative group">
          {loading ? (
            <div className="flex flex-col justify-center items-center h-80 gap-6">
              <div className="relative">
                <div className="w-20 h-20 rounded-[2rem] border-4 border-premium-gold/10 border-t-premium-gold animate-spin"></div>
                <Users className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-premium-gold/20" size={32} />
              </div>
              <p className="text-[10px] font-black text-premium-gold uppercase tracking-[0.6em] animate-pulse">Loading Users...</p>
            </div>
          ) : users && Array.isArray(users) ? (
            <div className="p-8">
              <UsersTable users={users} onEdit={handleEdit} />
            </div>
          ) : (
            <div className="text-center py-28 grayscale opacity-40">
              <div className="w-24 h-24 bg-gray-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-8 shadow-inner">
                <Users size={40} className="text-gray-200" />
              </div>
              <p className="text-gray-400 font-light italic tracking-wide">No Users Found.</p>
            </div>
          )}
        </div>
      </div>

      <UserModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        initialData={editingUser}
      />
    </MainLayout>
  );
}
